import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { LocalstorageService, Constants } from '../shared/shared';

// JWT Imports
import { AuthConfig, tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private localstorageService: LocalstorageService) { }

    canActivate() {
        //return true;
        let jwtToken = this.localstorageService.retrieve(Constants.JWT_ACCESSTOKEN_NAME);
        if (jwtToken) {
            if (tokenNotExpired(Constants.JWT_ACCESSTOKEN_NAME, jwtToken)) {
                console.log("JWT Token is not expired", []);
                return true;
            }
            else
                console.log("JWT Token expired");
        }
        else
            console.log("Token not available or expired. Redirect to login");

        this.router.navigate(['/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/_authentication/auth.guard.ts